// Client-provided photos
export const IMG_CAREVAN =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/hrg3zoqd_90a441_96344cca19e74623a9338d7d9c80d7cd~mv2.webp";
export const IMG_BLUEBEAR =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/1su3zghh_90a441_9d35c745223147ce9679c4de69cf9a66~mv2.webp";
export const IMG_CLINIC =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/te55kl63_13f462_18872eef7e6241cdb0bbb1a6ef8d37fd~mv2.webp";
export const IMG_PRODUCT1 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/5eaelt4i_product1.webp";
export const IMG_GRANT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/41gm0q3u_grant.png";

// Blog gallery images
export const IMG_1 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/l2an85ul_1.webp";
export const IMG_2 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/fmeav5ek_2.webp";
export const IMG_4 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/fykuujai_4.webp";
export const IMG_5 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/5d92xf7y_5.webp";
export const IMG_6 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/hre60e5g_6.webp";
export const IMG_7 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/4o6d11in_7.webp";
export const IMG_8 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/c7227hoh_8.webp";
export const IMG_9 =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/ciljej7l_9.webp";

// Partner logos
export const IMG_MM =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/1iqnqbvj_mm.webp";
export const IMG_BCBS =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/4j0969sg_bcbs.webp";
export const IMG_UMOJA =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/nlvo33qx_umoja.webp";
export const IMG_NMAAT =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_dental-care-abq/artifacts/icqsrk21_umoja.t.webp";
